export default __webpack_public_path__ + "static/media/arrow-left-disable.46a6be5a.svg";